export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6630.42d2bc36.jpg";